import axios from "axios";
const axiosReqConfig = async (url, method, values) => {
  try {
    const bearerToken =
      localStorage.getItem("token") || sessionStorage.getItem("token");
    const reqConfig = {
      url: url,
      method: method,
      headers: { Authorization: `Bearer ${bearerToken}` },
      data: values,
    };
    let dataInvalid = null;
    let isError = false;
    const { data } = await axios(reqConfig).catch(function (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        dataInvalid = error.response.data;
        isError = true;
      } else if (error.request) {
        return error.response.data;
      }
    });
    if (dataInvalid != null && isError) {
      console.log(dataInvalid);
      return dataInvalid;
    } else {
      return data;
    }
  } catch (error) {
    console.log(error);
  }
};

export { axiosReqConfig };
